export function formatDate(dateString) {
  if (dateString !== null && typeof dateString !== 'string') { throw new Error('Invalid dateString param supplied to formatDate'); }

  if (dateString === null) return null;
  return new Date(dateString).toLocaleDateString();
};

export function convertUnixTimeStamp(unixTimeStamp) {
  var unixEpoch = new Date(0); // The 0 there is the key, which sets the date to the epoch
  var actualDate = new Date(unixEpoch.getTime() + Number(unixTimeStamp));

  return actualDate;
}
